const TUI_PORTUGUESE_LANGUAGE_ADDON_COMMERCE = {
  cardNumber: ['Número', 'Número do Cartão'],
  cardExpiry: ['Validade', 'Validade do Cartão']
};
const TUI_PORTUGUESE_LANGUAGE_ADDON_EDITOR = {
  colorSelectorModeNames: ['Cor sólida', 'Gradiente'],
  toolbarTools: {
    undo: 'Desfazer',
    redo: 'Refazer',
    font: 'Fonte',
    fontStyle: 'Estilo da Fonte',
    fontSize: 'Tamanho da Fonte',
    bold: 'Negrito',
    italic: 'Itálico',
    underline: 'Sublinhado',
    strikeThrough: 'Riscado',
    justify: 'Justificado',
    justifyLeft: 'Justificado à esquerda',
    justifyCenter: 'Justificado ao centro',
    justifyRight: 'Justificado à direita',
    justifyFull: 'Totalmente justificado',
    list: 'Lista',
    indent: 'Recuo interno',
    outdent: 'Recuo externo',
    unorderedList: 'Lista desordenada',
    orderedList: 'Lista ordenada',
    quote: 'Frase',
    foreColor: 'Cor',
    backColor: 'Cor de fundo',
    hiliteColor: 'Cor destaque',
    clear: 'Limpar',
    link: 'Link',
    attach: 'Anexar arquivo',
    tex: 'Inserir TeX',
    code: 'Código',
    image: 'Inserir imagem',
    insertHorizontalRule: 'Inserir regra horizontal',
    superscript: 'Superscript',
    subscript: 'Subscript',
    insertTable: 'Insert table',
    hiliteGroup: 'Hilite group',
    insertGroup: 'Insert group',
    removeGroup: 'Remove group',
    insertAnchor: 'Insert anchor',
    mergeCells: 'Merge cells',
    splitCells: 'Split cells',
    rowsColumnsManaging: 'Managing rows and columns',
    cellColor: 'Cell color',
    setDetails: 'Details',
    removeDetails: 'Remove details'
  },
  editorEditLink: {
    urlExample: 'example.com',
    anchorExample: 'anchor'
  },
  editorTableCommands: [['Insert column before', 'Insert column after'], ['Insert row before', 'Insert row after'], ['Delete column', 'Delete row']],
  editorCodeOptions: ['Code in the text', 'Code in block'],
  editorFontOptions: {
    small: 'Small',
    normal: 'Normal',
    large: 'Large',
    title: 'Title',
    subtitle: 'Subtitle'
  }
};
const TUI_PORTUGUESE_LANGUAGE_ADDON_TABLE = {
  showHideText: 'Mostrar/Esconder',
  paginationTexts: {
    pages: 'Páginas',
    linesPerPage: 'Linhas por página',
    of: 'de'
  }
};
const TUI_PORTUGUESE_LANGUAGE_COUNTRIES = {
  AD: 'Andorra',
  AE: 'Emirados Árabes Unidos',
  AF: 'Afeganistão',
  AG: 'Antígua e Barbuda',
  AI: 'Anguila',
  AL: 'Albânia',
  AM: 'Armênia',
  AO: 'Angola',
  AR: 'Argentina',
  AT: 'Áustria',
  AU: 'Austrália',
  AW: 'Aruba',
  AZ: 'Azerbaijão',
  BA: 'Bósnia e Herzegovina',
  BB: 'Barbados',
  BD: 'Bangladesh',
  BE: 'Bélgica',
  BF: 'Burkina Faso',
  BG: 'Bulgária',
  BH: 'Bahréin',
  BI: 'Burundi',
  BJ: 'Benín',
  BL: 'São Bartolomeu',
  BM: 'Bermudas',
  BN: 'Brunéi',
  BO: 'Bolívia',
  BQ: 'Bonaire, Santo Eustáquio e Saba',
  BR: 'Brasil',
  BS: 'Bahamas',
  BT: 'Butão',
  BW: 'Botsuana',
  BY: 'Bielorrusia',
  BZ: 'Belice',
  CA: 'Canadá',
  CD: 'República Democrática do Congo',
  CF: 'República Centro-Africana',
  CG: 'Congo',
  CH: 'Suiça',
  CI: 'Costa do Marfim',
  CL: 'Chile',
  CM: 'Camarões',
  CN: 'China',
  CO: 'Colombia',
  CR: 'Costa Rica',
  CU: 'Cuba',
  CV: 'Cabo Verde',
  CW: 'Curaçau',
  CY: 'Chipre',
  CZ: 'República Checa',
  DE: 'Alemanha',
  DJ: 'Yibuti',
  DK: 'Dinamarca',
  DM: 'Dominica',
  DO: 'República Dominicana',
  DZ: 'Algeria',
  EC: 'Equador',
  EE: 'Estônia',
  EG: 'Egito',
  ER: 'Eritreia',
  ES: 'Espanha',
  ET: 'Etiópia',
  FI: 'Finlândia',
  FJ: 'Fiyi',
  FK: 'Ilhas Malvinas',
  FM: 'Micronesia',
  FR: 'França',
  GA: 'Gabão',
  GB: 'Reino Unido',
  GD: 'Granada',
  GE: 'Georgia',
  GF: 'Guiana',
  GH: 'Gana',
  GI: 'Gibraltar',
  GL: 'Groenlândia',
  GM: 'Gambia',
  GN: 'Guiné',
  GP: 'Guadalupe',
  GQ: 'Guiné Equatorial',
  GR: 'Grécia',
  GT: 'Guatemala',
  GW: 'Guiné-Bisssau',
  GY: 'Guiana',
  HK: 'Hong Kong',
  HN: 'Honduras',
  HR: 'Croácia',
  HT: 'Haiti',
  HU: 'Hungría',
  ID: 'Indonésia',
  IE: 'Irlanda',
  IL: 'Israel',
  IN: 'Índia',
  IQ: 'Iraque',
  IR: 'Irã',
  IS: 'Islândia',
  IT: 'Itália',
  JM: 'Jamaica',
  JO: 'Jordania',
  JP: 'Japão',
  KE: 'Kenia',
  KG: 'Quiirguistão',
  KH: 'Camboja',
  KM: 'Comoros',
  KN: 'São Cristóvão e Nevis',
  KP: 'Coreia do Norte',
  KR: 'Coreia do Sul',
  KW: 'Kuwait',
  KY: 'Ilhas Cayman',
  KZ: 'Kazaquistão',
  LA: 'Laos',
  LB: 'Líbano',
  LC: 'Santa Lucía',
  LI: 'Liechtenstein',
  LK: 'Sri Lanka',
  LR: 'Libéria',
  LS: 'Lesotho',
  LT: 'Lituânia',
  LU: 'Luxemburgo',
  LV: 'Letônia',
  LY: 'Líbia',
  MA: 'Marrocos',
  MC: 'Mônaco',
  MD: 'Moldavia',
  ME: 'Montenegro',
  MF: 'São Martinho',
  MG: 'Madagascar',
  MK: 'Macedônia',
  ML: 'Mali',
  MM: 'Myanmar',
  MN: 'Mongólia',
  MO: 'Macao',
  MQ: 'Martinica',
  MR: 'Mauritânia',
  MS: 'Montserrat',
  MT: 'Malta',
  MU: 'Mauricio',
  MV: 'Maldivas',
  MW: 'Malawi',
  MX: 'México',
  MY: 'Malasia',
  MZ: 'Moçambique',
  NA: 'Namibia',
  NC: 'Nova Caledónia',
  NE: 'Níger',
  NG: 'Nigéria',
  NI: 'Nicarágua',
  NL: 'Países Baixos',
  NO: 'Noruega',
  NP: 'Nepal',
  NZ: 'Nova Zelandia',
  OM: 'Omã',
  PA: 'Panamá',
  PE: 'Peru',
  PF: 'Polinesia Francesa',
  PG: 'Papua-Nova Guiné',
  PH: 'Filipinas',
  PK: 'Paquistão',
  PL: 'Polônia',
  PT: 'Portugal',
  PW: 'Palaos',
  PY: 'Paraguai',
  QA: 'Catar',
  RE: 'A reunião',
  RO: 'Romênia',
  RS: 'Sérbia',
  RU: 'Rússia',
  RW: 'Ruanda',
  SA: 'Arábia Saudita',
  SB: 'Ilhas Salomão',
  SC: 'Seychelles',
  SD: 'Sudão',
  SE: 'Suécia',
  SG: 'Singapura',
  SH: 'Santa Eena',
  SI: 'Eslovênia',
  SK: 'Eslováquia',
  SL: 'Serra Leoa',
  SM: 'San Marino',
  SN: 'Senegal',
  SO: 'Somália',
  SR: 'Suriname',
  ST: 'Santo Tomé e Príncipe',
  SV: 'El Salvador',
  SX: 'São Martinho',
  SY: 'Síria',
  SZ: 'Essuatíni',
  TC: 'Ilhas Turcas e Caicos',
  TD: 'Chad',
  TG: 'Togo',
  TH: 'Tailândia',
  TJ: 'Tajiquistão',
  TL: 'Timor Oriental',
  TM: 'Turkmenistán',
  TN: 'T´únez',
  TO: 'Tonga',
  TR: 'Turquia',
  TT: 'Trinidad e Tobago',
  TW: 'Taiwan',
  TZ: 'Tanzânia',
  UA: 'Ucrânia',
  UG: 'Uganda',
  US: 'Estados Unidos',
  UY: 'Uruguai',
  UZ: 'Uzbequistão',
  VC: 'São Vicente e Granadinas',
  VE: 'Venezuela',
  VG: 'Ilhas Virgens Británicas',
  VN: 'Vietnã',
  VU: 'Vanuatu',
  WS: 'Samoa',
  XK: 'Kosovo',
  YE: 'Yemén',
  YT: 'Maiote',
  ZA: 'África do Sul',
  ZM: 'Zâmbia',
  ZW: 'Zimbabwe',
  AC: 'Ascension Island',
  AS: 'American Samoa',
  AX: 'Åland Islands',
  CC: 'Cocos (Keeling) Islands',
  CK: 'Cook Islands',
  CX: 'Christmas Island',
  EH: 'Western Sahara',
  FO: 'Faroe Islands',
  GG: 'Guernsey',
  GU: 'Guam',
  IM: 'Isle of Man',
  JE: 'Jersey',
  IO: 'British Indian Ocean Territory',
  KI: 'Kiribati',
  MH: 'Marshall Islands',
  MP: 'Northern Mariana Islands',
  NF: 'Norfolk Island',
  NR: 'Nauru',
  NU: 'Niue',
  PM: 'Saint Pierre and Miquelon',
  PR: 'Puerto Rico',
  PS: 'Palestine',
  SJ: 'Svalbard and Jan Mayen',
  SS: 'South Sudan',
  TA: 'Tristan da Cunha',
  TK: 'Tokelau',
  TV: 'Tuvalu',
  VA: 'Holy See',
  VI: 'Virgin Islands',
  WF: 'Wallis and Futuna'
};
const TUI_PORTUGUESE_LANGUAGE_CORE = {
  months: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
  close: 'Fechar',
  clear: 'Limpar',
  nothingFoundMessage: 'Nada encontrado',
  defaultErrorMessage: 'Valor é inválido',
  spinTexts: ['Anterior', 'Próximo'],
  shortWeekDays: ['Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb', 'Dom'],
  countries: TUI_PORTUGUESE_LANGUAGE_COUNTRIES
};
const TUI_PORTUGUESE_LANGUAGE_KIT = {
  cancel: 'Cancelar',
  done: 'Concluir',
  more: 'Mais',
  otherDate: 'Outra data...',
  showAll: 'Show all',
  hide: 'Hide',
  mobileCalendarTexts: ['Escolha o dia', 'Escolha o intervalo', 'Escolha os dias'],
  range: ['de', 'para'],
  countTexts: ['Mais', 'Menos'],
  time: {
    'HH:MM': 'HH:MM',
    'HH:MM AA': 'HH:MM AA',
    'HH:MM:SS': 'HH:MM:SS',
    'HH:MM:SS AA': 'HH:MM:SS AA',
    'HH:MM:SS.MSS': 'HH:MM:SS.MSS',
    'HH:MM:SS.MSS AA': 'HH:MM:SS.MSS AA'
  },
  dateTexts: {
    DMY: 'dd/mm/yyyy',
    MDY: 'mm/dd/yyyy',
    YMD: 'yyyy/mm/dd'
  },
  digitalInformationUnits: ['B', 'KiB', 'MiB'],
  passwordTexts: ['Mostrar senha', 'Esconder senha'],
  copyTexts: ['Copiar', 'Copiado'],
  shortCalendarMonths: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
  pagination: ['Página anterior', 'Próxima página'],
  fileTexts: {
    loadingError: 'Erro ao carregar',
    preview: 'Preview',
    remove: 'Remover'
  },
  inputFileTexts: {
    defaultLabelSingle: 'ou arraste\u00A0ele\u00A0aqui',
    defaultLabelMultiple: 'ou arraste\u00A0eles\u00A0aqui',
    defaultLinkSingle: 'Escolha um arquivo',
    defaultLinkMultiple: 'Escolha os arquivos',
    maxSizeRejectionReason: 'Arquivo ultrapassa o tamanho',
    formatRejectionReason: 'Formato do arquivo inválido',
    drop: 'Solte o arquivo aqui',
    dropMultiple: 'Solte os arquivos aqui'
  },
  multiSelectTexts: {
    all: 'Selecionar tudo',
    none: 'Selecione nenhum'
  },
  confirm: {
    yes: 'Sim',
    no: 'Não'
  },
  previewTexts: {
    rotate: 'Girar'
  },
  zoomTexts: {
    zoomOut: 'Reduzir o zoom',
    zoomIn: 'Mais Zoom',
    reset: 'Reiniciar'
  },
  phoneSearch: 'Introduza o país ou código'
};
const TUI_PORTUGUESE_LANGUAGE_LAYOUT = {
  inputSearch: {
    popular: 'Popular',
    history: 'Recent',
    placeholder: 'Type query',
    hotkey: 'to search',
    all: 'All',
    empty: 'Nothing found'
  }
};
const TUI_PORTUGUESE_LANGUAGE = {
  name: 'portuguese',
  ...TUI_PORTUGUESE_LANGUAGE_CORE,
  ...TUI_PORTUGUESE_LANGUAGE_KIT,
  ...TUI_PORTUGUESE_LANGUAGE_ADDON_TABLE,
  ...TUI_PORTUGUESE_LANGUAGE_ADDON_COMMERCE,
  ...TUI_PORTUGUESE_LANGUAGE_ADDON_EDITOR,
  ...TUI_PORTUGUESE_LANGUAGE_LAYOUT
};

/**
 * Generated bundle index. Do not edit.
 */

export { TUI_PORTUGUESE_LANGUAGE, TUI_PORTUGUESE_LANGUAGE_ADDON_COMMERCE, TUI_PORTUGUESE_LANGUAGE_ADDON_EDITOR, TUI_PORTUGUESE_LANGUAGE_ADDON_TABLE, TUI_PORTUGUESE_LANGUAGE_CORE, TUI_PORTUGUESE_LANGUAGE_COUNTRIES, TUI_PORTUGUESE_LANGUAGE_KIT, TUI_PORTUGUESE_LANGUAGE_LAYOUT };
